module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_9005.39281c66.png";